import { CustomReportApiModel } from "../api-models";

export interface CustomReportMemberTag {
  id: string;
  text: string;
  hasReport: boolean;
}

export const validationErrors = (group: CustomReportApiModel): string[] => {
  const errors = [] as string[];
  let reportCount = 0;

  group.memberTags.forEach((tag) => {
    if (tag.hasReport) {
      reportCount += 1;
    }
  });

  if (group.name === null || group.name === "" || group.name === undefined) {
    errors.push("Please pick a name for your report.");
  }

  if (group.name.length > 127) {
    errors.push("The report's name is too long.");
  }

  if (reportCount < 2) {
    if (group.kind === "Team") {
      errors.push("Team reports must have at least two people in them who have done Solo.");
    } else if (group.kind === "TeamViewpoints") {
      errors.push(
        "Team Viewpoints reports require at least two people in them who have a Viewpoints report.",
      );
    } else if (group.kind === "Viewpoints") {
      errors.push("Viewpoints reports must have at least two people in them.");
    } else {
      errors.push("This aggregate report needs at least two people with reports in it.");
    }
  }

  return errors;
};
